<template>
  <Overlay :show="show">
    <div class="wrapper" @click.stop>
      <div class="block">
        <span class="close" @click="close">关闭</span>

        <div class="background">
          <van-image :src="QRCodeImg" class="vanImg" />
        </div>

        <div class="submit">立即截图微信扫一扫进入</div>
      </div>
    </div>
  </Overlay>
</template>

<script>
import { Overlay, Image as VanImage } from 'vant'
export default {
  name: 'QRCodeDialog',
  components: { Overlay, VanImage },
  data() {
    return {
      QRCodeImg: null,
      show: false,
    }
  },
  beforeDestroy() {},
  methods: {
    open(QRCodeImg) {
      this.show = true
      this.QRCodeImg = QRCodeImg
    },
    close() {
      this.show = false
    },
  },
}
</script>

<style lang="less" scoped>
.van-overlay {
  z-index: 99;
  text-align: center;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    position: relative;
    width: 726px;
    height: 898px;
    margin: 0 auto;
    .close {
      position: absolute;
      display: inline-block;
      padding: 10px 20px;
      font-size: 26px;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      right: 20px;
      top: -60px;
    }

    .background {
      width: 100%;
      height: 100%;
      .vanImg {
        width: 100%;
        height: 100%;
      }
    }

    .submit {
      position: absolute;
      bottom: -13.67vw;
      left: 50%;
      margin-left: -199px;
      font-size: 40px;
      font-weight: 600;
      color: #ffffff;
      line-height: 1em;
      padding: 20px 0;

      border-radius: 40px;
    }
  }
}
</style>
